import { createContext, useContext } from "react";
import useStore from "../../stores/common/useStore";
import PlaceARaffleStore from "./PlaceARaffleStore";

export const PlaceARaffleStoreContext = createContext<
  PlaceARaffleStore | undefined
>(undefined);

interface PlaceARaffleStoreProps {
  children: React.ReactNode;
}

export const PlaceARaffleProvider = ({
  children,
}: PlaceARaffleStoreProps): JSX.Element => {
  const placeARaffleStore = useStore(PlaceARaffleStore, []);

  return (
    <PlaceARaffleStoreContext.Provider value={placeARaffleStore}>
      {children}
    </PlaceARaffleStoreContext.Provider>
  );
};

const usePlaceARaffleStore = () => {
  const store = useContext(PlaceARaffleStoreContext);

  if (!store)
    throw new Error(
      "usePlaceARaffleStore should be called inside PlaceARaffleStoreProvider"
    );

  return store;
};

export default usePlaceARaffleStore;
